import type * as api from '@gitbook/api-client';

import { SearchButton, type SearchButtonProps } from './SearchButton';

export interface OrganizationSearchButtonProps extends Omit<SearchButtonProps, 'ai'> {
    organization: api.Organization;
}

export function OrganizationSearchButton(props: OrganizationSearchButtonProps) {
    const { organization, ...rest } = props;
    return <SearchButton ai={organization.ai ?? false} {...rest} />;
}
